import { render, staticRenderFns } from "./set_activity.vue?vue&type=template&id=380a717e&scoped=true"
import script from "./set_activity.vue?vue&type=script&lang=js"
export * from "./set_activity.vue?vue&type=script&lang=js"
import style0 from "./set_activity.vue?vue&type=style&index=0&id=380a717e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380a717e",
  null
  
)

export default component.exports